module.exports = "/_next/static/images/8156f9f5f3e39c42f13b4986930d2aad-hero-xs.jpg.webp";